import { render } from "./ViewProfile.vue?vue&type=template&id=3362d656"
import script from "./ViewProfile.vue?vue&type=script&lang=js"
export * from "./ViewProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__